import { Link } from "react-router-dom";

export default function Footer() {
	return (
		<div className="sm:fixed sm:z-20 relative inset-x-0 bottom-0 bg-white">
			<hr className="h-1" />
			<div className="flex flex-row w-3/4 self-center mx-auto sm:[&>div]:p-4 [&>div]:p-2 [&_a]:text-sm [&_a]:text-slate-500">
				<div>
					<Link to="/About/Privacy">Privacy Policy</Link>
				</div>
				<div>
					<Link to="/About/TOS">Terms of Service</Link>
				</div>

				<div>
					<Link to="/About">About</Link>
				</div>
				<div>
					<Link to="/About/Contact">Contact</Link>
				</div>
			</div>
		</div>
	);
}
